var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWavyLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 58,
    viewBox: "0 0 175 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.1304C30.1013 29.1304 35.744 10 58.8612 10C81.9784 10 74.3333 34 102.365 34C130.397 34 128.577 16.7826 141.137 16.2609C153.696 15.7391 149.328 34 181 34",
    stroke: "url(#paint0_linear)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.1304C30.1013 29.1304 35.744 10 58.8612 10C81.9784 10 74.3333 34 102.365 34C130.397 34 128.577 16.7826 141.137 16.2609C153.696 15.7391 149.328 34 181 34",
    stroke: "url(#paint1_linear)",
    strokeOpacity: 0.1,
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29.1304C30.1013 29.1304 35.744 10 58.8612 10C81.9784 10 74.3333 34 102.365 34C130.397 34 128.577 16.7826 141.137 16.2609C153.696 15.7391 149.328 34 181 34",
    stroke: "url(#paint2_linear)",
    strokeOpacity: 0.15,
    strokeWidth: 15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 38.4512C13.1013 38.4512 7.09154 19 30.2087 19C53.3259 19 41.0672 48 69.0991 48C97.1309 48 90.1258 21.8293 108.412 21.8293C127.351 21.8293 132.328 43.4024 164 43.4024",
    stroke: "url(#paint3_linear)",
    strokeOpacity: 0.75,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 38.4512C13.1013 38.4512 7.09154 19 30.2087 19C53.3259 19 41.0672 48 69.0991 48C97.1309 48 90.1258 21.8293 108.412 21.8293C127.351 21.8293 132.328 43.4024 164 43.4024",
    stroke: "url(#paint4_linear)",
    strokeOpacity: 0.05,
    strokeWidth: 20
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 38.4512C13.1013 38.4512 7.09154 19 30.2087 19C53.3259 19 41.0672 48 69.0991 48C97.1309 48 90.1258 21.8293 108.412 21.8293C127.351 21.8293 132.328 43.4024 164 43.4024",
    stroke: "url(#paint5_linear)",
    strokeOpacity: 0.1,
    strokeWidth: 15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.3674,
    y1: 30.6956,
    x2: 184.695,
    y2: 34.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.3674,
    y1: 30.6956,
    x2: 184.695,
    y2: 34.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 15.3674,
    y1: 30.6956,
    x2: 184.695,
    y2: 34.0804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: -1.63256,
    y1: 40.0426,
    x2: 167.697,
    y2: 43.3716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#003340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: -1.63256,
    y1: 40.0426,
    x2: 167.697,
    y2: 43.3716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#003340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: -1.63256,
    y1: 40.0426,
    x2: 167.697,
    y2: 43.3716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348958,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#00FFB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#003340"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyLine);
export default __webpack_public_path__ + "static/media/wavy-line.2dc5fa3a1c768facefeb36f7f9a844f7.svg";
export { ForwardRef as ReactComponent };